import { render, staticRenderFns } from "./OperationDoctor.vue?vue&type=template&id=052d9ca7&scoped=true"
import script from "./OperationDoctor.vue?vue&type=script&lang=js"
export * from "./OperationDoctor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052d9ca7",
  null
  
)

export default component.exports